import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseImageDefaults from '../BaseImage/BaseImage.defaults'
import swipeableGridDefaults from '../SwipeableGrid/SwipeableGrid.defaults.js'
import baseButtonDefaults from '../BaseButton/BaseButton.defaults'

export default {
  ...cloneDeep(baseDefaults),
  swipeableGrid: merge(cloneDeep(swipeableGridDefaults), {
    spacing: {
      desktop: 16
    },
    dotPosition: {
      desktop: -20
    }
  }),
  title: {
    tagName: 'h3',
    variant: 'smallHeading',
    text: 'Your title here!',
    color: undefined
  },
  description: {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    color: 'var(--color-text)'
  },
  items: [],
  spacing: {
    title: {
      desktop: 10
    },
    image: {
      desktop: 10
    },
    button: {
      desktop: 14
    }
  },

  imagePosition: 'top',
  image: merge(cloneDeep(baseImageDefaults), {
    width: 'custom',
    customWidth: {
      desktop: {
        value: 80,
        unit: 'px'
      }
    }
  }),
  button: cloneDeep(baseButtonDefaults)
}
